import { supabase } from './supabase';

export async function logPlatformAccess({
  tenantId,
  action,
  tableName,
  recordId,
  querySnapshot,
}: {
  tenantId: string;
  action: 'read' | 'update' | 'delete';
  tableName: string;
  recordId?: string;
  querySnapshot?: string;
}): Promise<void> {
  try {
    await supabase.rpc('log_platform_access', {
      p_tenant_id: tenantId,
      p_action: action,
      p_table_name: tableName,
      p_record_id: recordId ?? null,
      p_query_snapshot: querySnapshot ?? null,
    });
  } catch (err) {
    // Never throw — audit failure must not block primary operations
    console.error('Audit log failed:', err);
  }
}
